export default __webpack_public_path__ + "static/media/PREMIOS_IMPULSO_TORRE_SANTA_FE.f61a315f.pdf";